import {
  Alert,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  TextField,
} from "@mui/material";
import { useEffect, useState } from "react";
import JalaliDatePicker from "../../../components/shared/jalali-datepicker";
import { formatApiDate } from "../../SLN/market-growth/utils/commissionValidation";

const MOBILE_PATTERN = /^09\d{9}$/;

const normalizeMobile = (value) => {
  const digits = String(value || "").replace(/\D/g, "");
  if (digits.length === 10 && digits.startsWith("9")) return `0${digits}`;
  if (digits.length === 11 && digits.startsWith("09")) return digits;
  return digits;
};

const CreateSubPartnerDialog = ({ open, onClose, onSubmit, saving, parentProfile }) => {
  const [form, setForm] = useState({
    mobileNumber: "",
    fullName: "",
    initialSharePercent: "",
    effectiveFrom: new Date(),
  });
  const [errors, setErrors] = useState({});
  const [submitError, setSubmitError] = useState(null);

  useEffect(() => {
    if (!open) return;
    setForm({
      mobileNumber: "",
      fullName: "",
      initialSharePercent: "",
      effectiveFrom: new Date(),
    });
    setErrors({});
    setSubmitError(null);
  }, [open]);

  const handleChange = (field, value) => {
    setForm((prev) => ({ ...prev, [field]: value }));
    if (errors[field]) setErrors((prev) => ({ ...prev, [field]: null }));
    if (submitError) setSubmitError(null);
  };

  const validate = () => {
    const next = {};
    const mobile = normalizeMobile(form.mobileNumber);
    if (!mobile) {
      next.mobileNumber = "شماره موبایل الزامی است.";
    } else if (!MOBILE_PATTERN.test(mobile)) {
      next.mobileNumber = "شماره موبایل باید ۱۱ رقم و با 09 شروع شود.";
    }
    const share = Number(form.initialSharePercent);
    if (!share || share <= 0 || share > 100) {
      next.initialSharePercent = "سهم اولیه باید بین ۱ تا ۱۰۰ باشد.";
    }
    if (!form.effectiveFrom) next.effectiveFrom = "تاریخ شروع الزامی است.";
    return next;
  };

  const handleSubmit = async () => {
    const validationErrors = validate();
    if (Object.keys(validationErrors).length) {
      setErrors(validationErrors);
      return;
    }
    const payload = {
      mobileNumber: normalizeMobile(form.mobileNumber),
      initialSharePercent: Number(form.initialSharePercent),
      effectiveFrom: formatApiDate(form.effectiveFrom),
    };
    if (form.fullName?.trim()) payload.fullName = form.fullName.trim();
    const result = await onSubmit(payload);
    if (result?.error) setSubmitError(result.error);
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>ایجاد زیرمجموعه</DialogTitle>
      <DialogContent dividers>
        {submitError ? (
          <Alert severity="error" sx={{ mb: 2 }}>
            {submitError}
          </Alert>
        ) : null}
        {parentProfile?.commissionGroupTitle || parentProfile?.commissionGroupId ? (
          <Alert severity="info" sx={{ mb: 2 }}>
            زیرمجموعه با همان گروه پورسانتی شما ایجاد می‌شود:{" "}
            <strong>
              {parentProfile.commissionGroupTitle ||
                `شناسه ${parentProfile.commissionGroupId}`}
            </strong>
          </Alert>
        ) : (
          <Alert severity="warning" sx={{ mb: 2 }}>
            گروه پورسانتی حساب شما تنظیم نشده است. قبل از ایجاد زیرمجموعه با پشتیبانی
            تماس بگیرید.
          </Alert>
        )}
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <TextField
              label="شماره موبایل"
              value={form.mobileNumber}
              onChange={(e) => handleChange("mobileNumber", e.target.value)}
              fullWidth
              required
              placeholder="09123456789"
              error={Boolean(errors.mobileNumber)}
              helperText={
                errors.mobileNumber ||
                "اگر اکانت وجود داشته باشد اتوماتیک انتخاب می‌شود؛ در غیر این صورت ساخته می‌شود."
              }
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              label="نام و نام خانوادگی (اختیاری)"
              value={form.fullName}
              onChange={(e) => handleChange("fullName", e.target.value)}
              fullWidth
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              label="سهم اولیه از پورسانت والد (%)"
              type="number"
              value={form.initialSharePercent}
              onChange={(e) => handleChange("initialSharePercent", e.target.value)}
              fullWidth
              required
              error={Boolean(errors.initialSharePercent)}
              helperText={errors.initialSharePercent}
            />
          </Grid>
          <Grid item xs={12}>
            <JalaliDatePicker
              label="تاریخ شروع اعتبار"
              value={form.effectiveFrom}
              onChange={(value) => handleChange("effectiveFrom", value ? new Date(value) : null)}
              fullWidth
              error={Boolean(errors.effectiveFrom)}
              helperText={errors.effectiveFrom}
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={saving}>
          انصراف
        </Button>
        <Button variant="contained" onClick={handleSubmit} disabled={saving}>
          {saving ? "در حال ذخیره..." : "ایجاد"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CreateSubPartnerDialog;
